<template>
	<div>
		<!-- heading  -->
		<div class="flex gap-x-4 items-center mb-4">
			<!-- this should be tabs on mobile -->
			<h3
				v-if="editOffer === null"
				class="text-2xl text-gray-700 font-semibold"
				:class="trade == 'sell' ? 'order-1' : 'order-2'"
			>
				{{ labels.heading }}
			</h3>
			<h3 v-else class="text-2xl text-gray-700 font-semibold">
				{{ editOffer.id ? __(labels.edit) : __(labels.new) }}
			</h3>

			<!-- view switcher for mobile -->
			<ui-button
				v-if="editOffer === null"
				type="secondary"
				v-on:click="$emit('toggle-show-results-on-mobile')"
				class="md:hidden text-2xl"
				:class="trade == 'sell' ? 'order-2' : 'order-1'"
				>{{ labels.other }}</ui-button
			>

			<!-- create new button -->
			<ui-button
				class="ml-auto px-1.5 sm:px-4 order-3"
				v-if="editOffer === null"
				v-on:click="editOffer = defaultOffer"
				type="primary"
			>
				<span class="hidden sm:block">{{ labels.new }}</span>
				<!-- {{ __('New') }} -->
				<span class="block sm:hidden"
					><ui-icon name="plus" stroke-width="2" class="w-4 h-4"
				/></span>
			</ui-button>

			<ui-button
				v-else
				class="ml-auto px-1.5 sm:px-4 order-2"
				type="secondary"
				v-on:click="editOffer = null"
			>
				<span class="hidden sm:block">{{ __("Cancel") }}</span>
				<span class="block sm:hidden"
					><ui-icon name="x" stroke-width="2" class="w-4 h-4"
				/></span>
			</ui-button>
		</div>

		<!-- List -->
		<paper-offers-list
			v-if="editOffer === null"
			:trade="trade"
			:offers="filteredOffers"
			v-on:edit-offer="setEditOffer"
		/>

		<!-- Form -->
		<paper-offers-edit
			v-else
			:trade="trade"
			:offer="editOffer"
			:filter-options="filterOptions"
			:active-futures="activeFutures"
			v-on:close="editOffer = null"
		/>
	</div>
</template>

<script>
export default {
	props: {
		trade: {
			type: String,
			required: true,
		},
		offers: {
			type: Array,
			required: true,
		},
		filterOptions: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		let labels = {
			buy: {
				heading: this.__("Buyer"),
				other: this.__("Seller"),
				new: this.__("New purchase listing"),
				edit: this.__("Update purchase listing"),
			},
			sell: {
				heading: this.__("Seller"),
				other: this.__("Buyer"),
				new: this.__("New sales listing"),
				edit: this.__("Update sales listing"),
			},
		};
		return {
			labels: labels[this.trade],
			editOffer: null,
			defaultOffer: {
				type: "OFFER",
				trade: this.trade.toUpperCase(),
				product: {
					origin: "EU",
					type: null,
					grade: null,
					harvest: null,
				},
				location: {
					hub: "",
				},
				qty: {
					mt: null,
				},
				quality: {
					protein_min: null,
				},
				price: {
					type: null,
					mt: null,
					basis: null,
					commodity_future_id: null,
				},
				date: {
					type: null,
					month_from: null,
					month_to: null,
				},
			},
		};
	},
	computed: {
		filteredOffers() {
			let mine = this.filterOptions["mine"],
				selectedHubs = this.getSelectedIds(this.filterOptions["locationHubs"]),
				selectedGrades = this.getSelectedIds(
					this.filterOptions["productGrades"]
				),
				selectedHarvests = this.getSelectedIds(
					this.filterOptions["productYears"]
				),
				selectedDates = this.getSelectedIds(this.filterOptions["dateType"]);

			return this.offers
				.filter((offer) => (mine ? offer.mine : true))
				.filter(
					(offer) =>
						selectedHubs.length == 0 ||
						selectedHubs.includes(offer.location.hub)
				)
				.filter(
					(offer) =>
						selectedGrades.length == 0 ||
						(!offer.product.grade.includes("WHEAT_B") &&
							selectedGrades.includes(offer.product.grade)) ||
						(offer.product.grade.includes("WHEAT_B") &&
							selectedGrades.includes("WHEAT_B"))
				)
				.filter(
					(offer) =>
						selectedHarvests.length == 0 ||
						selectedHarvests.includes(offer.product.harvest)
				)
				.filter(
					(offer) =>
						selectedDates.length == 0 ||
						(selectedDates.includes("AT_HARVEST") &&
							offer.date.type == "AT_HARVEST") ||
						(selectedDates.includes("MONTH") &&
							offer.date.type != "AT_HARVEST" &&
							this.intervalCheck(offer.date.month_from, offer.date.month_to))
				);
		},
	},
	methods: {
		getSelectedIds(filterOption) {
			return filterOption
				.filter((option) => option.checked)
				.map((option) => option.value);
		},
		setEditOffer(editOffer) {
			this.editOffer = editOffer;
		},
		showFilter() {
			this.$emit("toggle-show-results-on-mobile", false);
		},
		intervalCheck(month_from, month_to) {
			let selectedMonthFrom = this.filterOptions.monthType.month_from,
				selectedMonthTo = this.filterOptions.monthType.month_to,
				leftCheck =
					selectedMonthFrom == null ||
					month_from == null ||
					month_from >= selectedMonthFrom,
				rightCheck = selectedMonthTo == null || selectedMonthTo >= month_to;
			return leftCheck && rightCheck;
		},
	},
	created() {
		let offerEditRequest = window.location.hash.match(
			"#" + this.trade + "([^\d]+)"
		);
		if (offerEditRequest) {
			let offers = JSON.parse(JSON.stringify(this.offers)),
				offer = offers
					.filter((offer) => offer.mine == true)
					.filter((offer) => offer.id == offerEditRequest[1]);

			this.editOffer = offer.length > 0 ? offer : null;
		}
	},
	/*
    watch: {
        editOffer() {
            if (this.editOffer == null) {
                this.success = false;
            }

        }
    }
    */
};
</script>
